export default __webpack_public_path__ + "static/media/whatsapp-help.2890d457.svg";